// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_kj-0";
export var fileCarousel = "_kj-2";
export var removeFileButton = "_kj-1";